import { StockLevelStatus } from "../../../pages/products/StockLevels/types";
import { ResourceType } from "../types";

export class StockListParams {
  page?: number;
  size?: number;
  sort?: string;
  warehouse_id?: string;
  resource_type?: ResourceType;
  search?: string;
  product_name?: string;
  ean?: string;
  product_system_id?: string;
  category_id?: string;
  category_name?: string;
  warehouse_name?: string;
  status?: StockLevelStatus;

  constructor(partial: Partial<StockListParams> = {}) {
    this.page = partial.page;
    this.size = partial.size;
    this.sort = partial.sort;
    this.warehouse_id = partial.warehouse_id;
    this.resource_type = partial.resource_type;
    this.search = partial.search;
    this.product_name = partial.product_name;
    this.ean = partial.ean;
    this.product_system_id = partial.product_system_id;
    this.category_id = partial.category_id;
    this.category_name = partial.category_name;
    this.warehouse_name = partial.warehouse_name;
    this.status = partial.status;
  }
}